"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

var _useStyles2 = _interopRequireDefault(require("./useStyles"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var DropdownNavigation = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var item = _ref.item;

  var _useStyles = (0, _useStyles2["default"])(),
      a = _useStyles.a;

  var shouldRenderDropdown = Array.isArray(item.items) && item.items.length > 0;
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    component: "li"
  }, !shouldRenderDropdown ? /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({}, (0, _helpers.getButtonProps)(item), {
    className: a
  }), item.label) : /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    item: item,
    ref: ref
  }));
});

DropdownNavigation.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  item: _propTypes["default"].object.isRequired
};
var _default = DropdownNavigation;
exports["default"] = _default;